import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const titleProps = ({ theme }) => css`
  font-weight: bold;
  color: var(--grey900);
  background-color: var(--grey100);
  text-transform: uppercase;
  font-size: ${theme.base.textSizes.M};
`;

export default styled(Flexer.Parent).attrs(() => ({
  p: 'S',
}))`
  ${titleProps}
`;
